module.exports = __webpack_public_path__ + "img/representative.859d4304.jpg";